import React, { useContext } from 'react';
import { TrendingSmall, DownwardtrendSmall } from '@wix/wix-ui-icons-common';
import { st, classes } from './TrendIndicator.st.css';
import { dataHooks } from './TrendIndicator.constants';
import { useIcons } from '../WixDesignSystemIconThemeProvider';
import { WixStyleReactEnvironmentContext } from '../WixStyleReactEnvironmentProvider/context';
import { TrendIndicatorProps } from './TrendIndicator.types';

const TrendIndicatorInner = ({
  value,
  inverted = false,
  className,
  dataHook,
  locale,
  format = 'percent',
}: TrendIndicatorProps) => {
  const context = useContext(WixStyleReactEnvironmentContext);
  const effectiveLocale = locale || context.locale;
  const icons = useIcons('TrendIndicator', {
    TrendingSmall,
    DownwardtrendSmall,
  });

  if (isNaN(Number(value))) {
    return null;
  }

  let skin = 'neutral';
  let trendIcon: React.ReactElement | null = null;

  if (value > 0) {
    trendIcon = <icons.TrendingSmall data-hook={dataHooks.trendIndicatorUp} />;
    skin = !inverted ? 'positive' : 'negative';
  } else if (value < 0) {
    trendIcon = (
      <icons.DownwardtrendSmall data-hook={dataHooks.trendIndicatorDown} />
    );
    skin = !inverted ? 'negative' : 'positive';
  }

  return (
    <div className={st(classes.root, { skin }, className)} data-hook={dataHook}>
      <div className={classes.caption}>
        {!!value && (
          <span
            className={classes.icon}
            data-hook={dataHooks.trendIndicatorIcon}
          >
            {trendIcon}
          </span>
        )}
        <span data-hook={dataHooks.trendIndicatorValue}>
          {new Intl.NumberFormat(effectiveLocale, { style: format }).format(
            Math.abs(value) / (format === 'percent' ? 100 : 1),
          )}
        </span>
      </div>
    </div>
  );
};

const TrendIndicator = (props: TrendIndicatorProps) => (
  <WixStyleReactEnvironmentContext.Provider value={{ locale: 'en' }}>
    <TrendIndicatorInner {...props} />
  </WixStyleReactEnvironmentContext.Provider>
);

TrendIndicator.displayName = 'TrendIndicator';

export default TrendIndicator;
